import React, { Component } from 'react';
import { Button } from "reactstrap";
import Prism from "prismjs";
import "prismjs/themes/prism-coy.css";
import "prismjs/components/prism-java.js"
import "prismjs/components/prism-javascript.js";
import "prismjs/components/prism-python.js";
import "prismjs/components/prism-csharp.js";
import { ButtonGroup } from "react-bootstrap";

class ShowCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isToggleOn: true,
            previousButton: 'java',
            codeName: 'java'
        };

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
        this.handleClickButton = this.handleClickButton.bind(this);
        this.handleClickCopy = this.handleClickCopy.bind(this);
        this.showCodes = this.showCodes.bind(this);

    }

    handleClick() {
        let self = this;
        const isToggleOn = self.props.isOpenDetail;
        self.setState(() => self.props.listener(!isToggleOn));
    }
    handleClickButton(type) {
        let self = this;
        self.setState({ codeName: type });
        document.getElementById(this.state.previousButton).style = "color: black;";
        this.setState({ previousButton: type });
        document.getElementById(type).style = "background: #358ccb; color: white;";
    }
    handleClickCopy() {
        navigator.clipboard.writeText(document.getElementById("url").innerHTML)
    }
    componentDidUpdate() {
        Prism.highlightAll();
    }
    componentDidMount() {
        Prism.highlightAll();
    }

    showCodes() {
        let language = this.state.codeName;
        let code;
        this.props.code.map(data => {
            if (data.language == language)
                code = data;
        });
        return <pre className={'language-' + language}  ><code style={{whiteSpace:"pre-wrap",wordBreak: "break-word !important;",overflowY:"scroll",maxHeight:"350px"}}>{code.context}</code></pre>;
    }
    downloadTxtFile = (codeName)=>{
        let language = codeName;
        let code;
        if(this.props.code){
            this.props.code.map(data => {
                if (data.language == language)
                    code = data;
            });
            const element = document.createElement("a");
            const file = new Blob([code.context], {type: 'text/plain'});
            element.href = URL.createObjectURL(file);
            element.download = language+".txt";
            document.body.appendChild(element); // Required for this to work in FireFox
            element.click();
        }

    }

    render() {
        return (
            <div>
                {this.props.code != undefined && this.props.code != null && this.props.code.length != 0 &&
                    <ButtonGroup id="code-grp" className="show-code-btn-container">
                        <div className="btn-group code-select-btn">
                            <Button size="sm" className="" type="button" onClick={() => this.handleClickButton('java')}
                                    style={{background: "#358ccb"}} id="java">Java</Button>{' '}
                            <Button onClick={() => this.downloadTxtFile('java')} className="downloadBtn"><i
                                className="fas fa-download"></i></Button>
                        </div>
                        <div className="btn-group code-select-btn ">
                            <Button size="sm" className="languageButton" type="button"
                                    onClick={() => this.handleClickButton('php')} id="php">php</Button>{' '}
                            <Button onClick={() => this.downloadTxtFile('php')} className="downloadBtn"><i
                                className="fas fa-download"></i></Button>
                        </div>
                        <div className="btn-group code-select-btn">
                            <Button size="sm" className="languageButton" type="button"
                                    onClick={() => this.handleClickButton('csharp')} id="csharp">C#</Button>{' '}
                            <Button onClick={() => this.downloadTxtFile('csharp')} className="downloadBtn"><i
                                className="fas fa-download"></i></Button>
                        </div>
                        <div className="btn-group code-select-btn">
                            <Button size="sm" className="languageButton" type="button"
                                    onClick={() => this.handleClickButton('python')} id="python">Python</Button>{' '}
                            <Button onClick={() => this.downloadTxtFile('python')} className="downloadBtn"><i
                                className="fas fa-download"></i></Button>
                        </div>
                        <div className="btn-group code-select-btn">
                            <Button size="sm" className="languageButton" type="button"
                                    onClick={() => this.handleClickButton('javascript')}
                                    id="javascript">JS</Button>{' '}
                            <Button onClick={() => this.downloadTxtFile('javascript')} className="downloadBtn"><i
                                className="fas fa-download"></i></Button>
                        </div>
                    </ButtonGroup>
                }
                {this.props.url && this.props.method &&
                    <div className="post-Url">
                        <span className="post">{this.props.method}</span>
                        <span className="url" id="url">{this.props.url}</span>

                        <Button size="sm" type="button" className="copyButton"
                                onClick={() => this.handleClickCopy()}>Kopyala</Button>
                    </div>
                }
                {this.props.code != undefined && this.props.code != null && this.props.code.length != 0 &&
                    <div className="showCode">
                        {this.showCodes()}
                    </div>
                }
            </div>
        );
    }
}

export default ShowCode;